import { connect } from "react-redux";

import { withMetrics } from "../../withMetrics";
import { withResolvePaths } from "../../withResolvePaths";
import { withViewModelSelect } from "../../withViewModelSelect";
import { withEvaluators } from "../../withEvaluators";
import { withFocusManagement } from "../../Services/FocusManagement/withFocusManagement";
import { withExternalMountingEventReporting } from "../../Services/ExternalMountingEventReporting/withExternalMountingEventReporting";
import { withControlDebugInfo } from "../../withControlDebugInfo";
import { withFormActionHandlerExecution } from "../../Internals/FormActionHandlers/WithFormActionHandlerExecution";

import { Picklist } from "./Picklist";
import { mapDispatchToProps, mapStateToProps } from "./Common/ReduxState/PicklistReduxState";

export const PicklistContainer = withMetrics(
    withResolvePaths(
        withFormActionHandlerExecution(
            withViewModelSelect(
                withEvaluators(
                    connect(
                        mapStateToProps,
                        mapDispatchToProps
                    )(withFocusManagement(withExternalMountingEventReporting(withControlDebugInfo(Picklist))))
                )
            )
        )
    )
);
